import React from 'react'
import { LayoutInterface } from './layout/LayoutInterface'

export const InterfaceScreen = () => {
    return (
        <LayoutInterface />
    )
}
